import { supabaseClient } from './supabase';
import { toast } from './toast';

export async function signIn(email: string, password: string) {
  try {
    const { error } = await supabaseClient.auth.signInWithPassword({ 
      email, 
      password 
    });
    if (error) throw error;
  } catch (error) {
    console.error('Sign in error:', error);
    throw error;
  }
}

export async function signUp(email: string, password: string) {
  try {
    const { error } = await supabaseClient.auth.signUp({ 
      email, 
      password,
      options: {
        data: { role: 'client' }
      }
    });
    if (error) throw error;
  } catch (error) {
    console.error('Sign up error:', error);
    throw error;
  }
}

export async function signOut() {
  try {
    // First try to get the current session
    const { data: { session } } = await supabaseClient.auth.getSession();

    // Clear all storage first to ensure clean state
    localStorage.clear();
    sessionStorage.clear();

    // Clear all cookies
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      const [name] = cookie.split('=');
      const trimmedName = name.trim();
      document.cookie = `${trimmedName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;`;
    }

    // If we have a session, sign out globally first
    if (session) {
      try {
        await supabaseClient.auth.signOut({ scope: 'global' });
      } catch (error) {
        console.warn('Global sign out failed:', error);
      }
    }

    // Finally sign out locally
    try {
      await supabaseClient.auth.signOut({ scope: 'local' });
    } catch (error) {
      console.warn('Local sign out failed:', error);
    }

    // Force reload the page to clear any remaining state
    window.location.href = '/login';
  } catch (error) {
    console.error('Sign out error:', error);
    
    // Even if there's an error, ensure everything is cleared
    try {
      localStorage.clear();
      sessionStorage.clear();
      
      const cookies = document.cookie.split(';');
      for (const cookie of cookies) {
        const [name] = cookie.split('=');
        const trimmedName = name.trim();
        document.cookie = `${trimmedName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;`;
      }
      
      await supabaseClient.auth.signOut({ scope: 'local' });
    } catch (clearError) {
      console.warn('Error clearing session:', clearError);
    }

    // Always redirect to login page
    window.location.href = '/login';
  }
}

// Function to check if user is authenticated
export async function checkAuth() {
  try {
    const { data: { session }, error } = await supabaseClient.auth.getSession();
    if (error) throw error;
    return !!session;
  } catch (error) {
    console.error('Error checking auth:', error);
    return false;
  }
}